import { ErrorBaseData } from '.'

export const cpfCnpjErrors: Record<string, ErrorBaseData> = {
  CpfCnpjApiException: {
    message: 'Erro ao obter dados do CPF',
    description: 'Verifique as informações e tente novamente',
  },
}
